import React from "react";
import classNames from "classnames";
import Icon from "#components/icon";
import { useTranslation } from "react-i18next";
import { ProductSyncStatus } from "#resources/api/enterprise-generated";
import s from "./sync-status-tag.scss";

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
	status: ProductSyncStatus;
}

const ICON_BY_STATUS = {
	synced: "synchronize",
	pending: "sync-warning",
	notSynced: "sync-warning",
} as const;

export function SyncStatusTag({ status, className, ...rest }: Props) {
	const { t } = useTranslation("place", {
		keyPrefix: "delivery.syncMenu.syncStatusTag",
	});

	const labelByStatus: Record<ProductSyncStatus, string> = {
		synced: t($ => $.synced),
		pending: t($ => $.pending),
		notSynced: t($ => $.notSynced),
	};

	return (
		<span className={classNames(s.tag, s[status], className)} {...rest}>
			<Icon icon={ICON_BY_STATUS[status]} width={16} />
			{labelByStatus[status]}
		</span>
	);
}
